

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../redux/actions/authActions'; // Import the logout action

const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // Dispatch logout action to call API and clear Redux state
    dispatch(logout());

    // Redirect to home page after logout
    navigate('/');
  }, [dispatch, navigate]);

  return null;
};

export default Logout;
